<script lang="ts">
    import { _ } from "svelte-i18n"
    import { iframeView } from "../../functionTools/iframeIntegration"

    import OfferAssistant from "../ecommerce/configurator/OfferAssistant.svelte"
    import { apiBaseURL, OfferAssistantFTPAssetsUrl } from "../../configs/config"

    let offerAssistantReset: boolean = $state(false)

    const submitInquirySuccessCallback = () => {
        offerAssistantReset = true
    }
</script>

<div id="offerAssistantPage">
    {#if !$iframeView}
        <div class="headline">
            <div class="headline-container">
                <h1>
                    {$_("product-config.configurator")}
                </h1>
            </div>
        </div>
    {/if}

    <div class="offerAssistantContainer" class:iframe={$iframeView} class:site={!$iframeView}>
        <OfferAssistant
            id="mailboxes"
            configUrl={apiBaseURL}
            ftpAssetsUrl={OfferAssistantFTPAssetsUrl}
            bind:reset={offerAssistantReset}
            {submitInquirySuccessCallback}
        />
    </div>
</div>

<style lang="less" global>
    @import "../../css/variables.less";

    #offerAssistantPage {
        background-color: var(--surface);
        color: var(--on-surface);
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .headline {
            padding: 0px var(--default-horizontal-padding);
            width: 100%;
            border-bottom: 1px solid var(--border-color-default);
            .flex();
            justify-content: space-between;
            align-items: stretch;
            position: relative;
            justify-content: center;

            .headline-container {
                display: flex;
                width: 100%;
                justify-content: flex-start;
                max-width: var(--max-container-width);
            }

            h1 {
                .flex();
                align-items: center;
                justify-content: center;
                margin: 0px;
                font-size: 1.5rem;
                padding: 15px 0px;
            }
        }

        .site.offerAssistantContainer {
            padding: 1.2rem var(--default-horizontal-padding);
            width: 100%;
            display: flex;
            justify-content: center;
            .offer-assistent-component {
                max-width: var(--max-container-width);
                .offer-assistent {
                    border: 0px solid black !important;
                    padding: 0px !important;
                }
            }
        }
        .iframe.offerAssistantContainer {
            padding: 0px;
            width: 100%;
            justify-content: flex-start;
        }
    }
</style>
